import { request } from "../api";

export interface CompanyQRResponse {
  label: string;
  raw_code: string;
  qr_payload: {
    v: number;
    kind: "bootstrap";
    api: string;
    bootstrap_code: string;
    company_slug: string;
    cleartext: boolean;
    verify_tls: boolean;
  };
  created_at: string;
}

export const companyQrApi = {
  get: () => request<CompanyQRResponse>("/api/admin/v1/companies/me/qr/"),
};
